import * as React from 'react';
import { FC } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { useRoute } from 'hooks/navigation/use-route';
import { selectors, useAppSelector } from 'state/global-state';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';
import { primitive } from 'styles/constants/primitives';
import { DIFFERENCE_TIME_UNITS, getDifferenceToNow } from 'utils/dateTime';
import { routes } from 'utils/routing';

import {
  CooldownDescription,
  CooldownTitle,
  CooldownWrapper,
  TextWrapper,
} from './loyalty-offers-cooldown.styled';

const LoyaltyOffersCooldown: FC<React.PropsWithChildren<unknown>> = () => {
  const { loyaltyUser } = useLoyaltyUser();
  const { formatMessage } = useIntl();
  const { pathname } = useRoute();
  const loyaltyOffersInCooldown = useAppSelector(selectors.loyalty.selectLoyaltyOffersInCooldown);
  const isOffersPage = pathname.includes(routes.offers);
  const showCooldown = loyaltyOffersInCooldown && isOffersPage;

  const diffInMin = getDifferenceToNow(
    DIFFERENCE_TIME_UNITS.MINUTES,
    loyaltyUser?.offerRedemptionAvailability?.availableAfter || ''
  );

  return showCooldown ? (
    <CooldownWrapper>
      <Icon variant="time" color={primitive.$white} marginTop="$2" />
      <TextWrapper>
        <CooldownTitle>{formatMessage({ id: 'offersCooldownTitle' })}</CooldownTitle>
        <CooldownDescription>
          {formatMessage(
            { id: 'offersCooldownDescription' },
            {
              minutes: diffInMin,
            }
          )}
        </CooldownDescription>
      </TextWrapper>
    </CooldownWrapper>
  ) : null;
};

export default LoyaltyOffersCooldown;
